import React, { useEffect, useMemo } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';

import { useCurrentEditor } from '@tiptap/react';

import useOutlineVersions from '../../hooks/outline/useOutlineVersions';
import EditorVersionHistory from '../buttons/EditorVersionHistory';

import { isCurrentAiProcessInProgress } from '../../../../../utils/helpers/aiOptimizerHelpers';
import { parseEditorContent } from '../../utils/versionHelpers';

import {
    setAIContentLoadingField,
    setAIOutlineLoadingProgress,
} from '../../../../pages/contentOptimizer/contentPage/content/briefTab/content/tabsContent/store/contentBriefsOutline.actions';
import { selectAIContentLoadingField } from '../../../../pages/contentOptimizer/contentPage/content/briefTab/content/tabsContent/store/contentBriefsOutline.selectors';
import { aiContentFields } from '../../../../pages/contentOptimizer/contentPage/content/briefTab/contentBriefsConstants';

import { selectCurrentEditorVersion } from '../../store/tiptapEditor.selectors';

import { editorTypes } from '../../constants/tiptapEditorConstants';

const editorType = editorTypes.OUTLINE;

const OutlineVersionHistory = () => {
    const dispatch = useDispatch();
    const { editor } = useCurrentEditor();

    const aiContentLoadingField = useSelector(selectAIContentLoadingField);
    const currentEditorVersion = useSelector(selectCurrentEditorVersion(editorType));

    const isAiOutlineInProgress = useMemo(() => {
        return (
            !!currentEditorVersion &&
            isCurrentAiProcessInProgress(currentEditorVersion.generation_status)
        );
    }, [currentEditorVersion]);

    const {
        createNewOutlineVersion,
        handleActivateOutlineVersion,
        handlePreviewOutlineVersion,
        handleUpdateVersionName,
        handleDeleteOutlineVersion,
        isVersionCreating,
    } = useOutlineVersions();

    useEffect(() => {
        if (aiContentLoadingField === aiContentFields.OUTLINE && !isAiOutlineInProgress) {
            const generatedContent = parseEditorContent(currentEditorVersion.outline, editorType);
            editor.commands.setContent(generatedContent);

            batch(() => {
                dispatch(setAIOutlineLoadingProgress(0));
                dispatch(setAIContentLoadingField(null));
            });
        }
    }, [isAiOutlineInProgress, aiContentLoadingField, currentEditorVersion, editor, dispatch]);

    return (
        <EditorVersionHistory
            disabled={!!aiContentLoadingField}
            editorType={editorType}
            createNewEditorVersion={createNewOutlineVersion}
            newEditorVersionCreating={isVersionCreating}
            handleActivateEditorVersion={handleActivateOutlineVersion}
            handlePreviewEditorVersion={handlePreviewOutlineVersion}
            handleUpdateVersionName={handleUpdateVersionName}
            handleDeleteEditorVersion={handleDeleteOutlineVersion}
        />
    );
};

export default OutlineVersionHistory;
